import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  ViewEncapsulation,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import { AppService } from "src/app/app.service";
import { ResearchPageDataService } from "../research-page-data.service";
import PDFViewer from "./pdf-viewer";
import { faSearchMinus, faSearchPlus } from "@fortawesome/pro-light-svg-icons";

@Component({
  selector: "app-research-viewer",
  templateUrl: "./research-viewer.component.html",
  styleUrls: ["./research-viewer.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ResearchViewerComponent implements OnInit {
  apiEP: string = window.apiUrl;
  @Input() researchDocId: number;
  @Input() docInfo: Dictionary<any>;
  @Input() ticker: string;
  @Output() downloadDoc = new EventEmitter<string>();
  isLoading = true;
  fileUrl: string;
  pdfViewer;
  faSearchMinus = faSearchMinus;
  faSearchPlus = faSearchPlus;
  documentType;
  documentTitle = "";
  documentSummary = "";
  constructor(
    private dataService: ResearchPageDataService,
    private appService: AppService,
  ) {}

  ngOnChanges() {
    this.documentType = "";
    this.documentTitle = "";
    this.documentSummary = "";
    this.isLoading = true;
    this.resetDocument();
  }
  ngOnInit() {
    this.documentType = "";
    this.documentTitle = "";
    this.documentSummary = "";
    this.isLoading = true;
  }
  resetDocument() {
    if (
      this.researchDocId &&
      this.docInfo &&
      this.docInfo.id === Number(this.researchDocId)
    ) {
      this.documentType =
        this.docInfo.mime_type === "htm"
          ? "html"
          : this.docInfo.mime_type.toLowerCase();
      this.documentTitle = this.docInfo.title;
      this.documentSummary = this.docInfo.synopsis;
      if (this.docInfo.mime_type !== "pdf") {
        this.isLoading = false;
      }
      this.dataService.getResearchDocument(this.researchDocId).subscribe(
        (response) => {
          const data = response.Data;
          const container = document.getElementById("viewerContainer");

          this.fileUrl = data.Url;
          if (this.documentType.toLowerCase() === "pdf") {
            // uncomment below line for local testing and put some pdf in assets folder with name test.pdf
            // this.fileUrl = `/assets/test.pdf`;

            this.pdfViewer = new PDFViewer(
              container,
              this.fileUrl,
              this.onPDFLoad.bind(this),
              this.onPDFLoad.bind(this),
            );
          } else if (this.documentType.toLowerCase() === "linkback") {
            if (data["SAML"]) {
              const iframeElm = document.getElementById(
                "linkbackIframe",
              ) as HTMLFormElement;
              document
                .getElementById("SAMLResponse")
                .setAttribute("value", data.SAML.SAMLResponse);
              document
                .getElementById("RelayState")
                .setAttribute("value", data.Url);
              iframeElm.setAttribute("action", data.SAML.SSOLoginUrl);
              setTimeout(() => {
                iframeElm.submit();
                this.isLoading = false;
              }, 100);
            }
          } else {
            this.isLoading = false;
          }
        },
        (e) => {
          console.error(e);
        },
      );
    } else {
      this.isLoading = true;
    }
  }
  onZoomOut() {
    this.pdfViewer.zoomOut();
  }
  onZoomIn() {
    this.pdfViewer.zoomIn();
  }
  onPDFLoad() {
    this.isLoading = false;
  }
  resetPdf() {
    if (this.pdfViewer) {
      this.pdfViewer.pdfViewer.currentScaleValue = "auto";
      setTimeout(() => {
        this.pdfViewer.resetPages();
      }, 250);
    }
  }

  viewHtmlDoc() {
    const extras = {
      beginning_state_referrer: "File_Viewer",
      research_id: this.researchDocId,
      research_type: this.documentType,
    };
    this.appService.logUserAction(
      {},
      this.ticker || "",
      "",
      "Research_Opened_FromViewer_MP",
      extras,
      "",
      "Research_ViewDocument",
    );
    const urlLink = `${this.apiEP}/resapi/get_doc_html?document_id=${this.researchDocId}`;
    window.open(urlLink, "_blank");
  }
  downloadDocument() {
    this.downloadDoc.emit("MP");
  }
}
